module.exports = __webpack_public_path__ + "media/images/billing/successful-e108b801587137a190cf8440bd7ae2a9.svg";